import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5 1C2.79086 1 1 2.79086 1 5V19C1 21.2091 2.79086 23 5 23H19C21.2091 23 23 21.2091 23 19V5C23 2.79086 21.2091 1 19 1H5ZM4.53871 11.4612L10.2206 5.77934C9.93575 7.21403 10.3493 8.75989 11.4612 9.87183L11.4613 9.87196L9.3333 12L12 14.6667L12 14.6667C13.2881 15.9549 13.4495 17.9431 12.4842 19.4067C12.3459 19.6164 12.1845 19.8153 11.9999 19.9999L8.26926 16.2693L4.53871 12.5387C4.24117 12.2412 4.24117 11.7588 4.53871 11.4612ZM13.3006 10.6337L13.3005 10.6338L14.6667 12L12.5387 14.1279C13.6508 15.24 14.0642 16.7861 13.7791 18.2209L19.4613 12.5387C19.7588 12.2412 19.7588 11.7588 19.4613 11.4612L12 4L11.9722 4.02782C11.7991 4.20443 11.647 4.39382 11.5157 4.59293C10.5503 6.0566 10.7118 8.04488 12 9.33308L13.3006 10.6337Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }